import { Init } from "@pdfking/reactivity/preact"
import { CreateSingleton } from "@pdfking/tfunc"
import has_dom from "@pdfking/workflow/utils/has_dom"
import start_request from "../navigation/start_request"

export default CreateSingleton(() =>
  Init({
    methods: {
      push_state(url: string) {
        console.info(`pushing url to history: ${url}`)
        window.history.pushState({ url }, "", url)
      },
      replace_state(url: string) {
        console.info(`replace url to history: ${url}`)
        window.history.replaceState({ url }, "", url)
      },
    },
  })
)

if (has_dom()) {
  window.onpopstate = (_e: PopStateEvent) => {
    if (!window.location.hash)
      start_request(window.location.href, {
        change_location: false,
        data: null,
      })
  }
}
